<template>
    <div class="video-player" v-if="videoId">
        <a @click="showModal = true" class="play-btn">
            <img :src="videoThumb" v-if="videoThumb" />
        </a>
        <portal to="video-modal">
            <modal
                v-if="showModal"
                @close="showModal = false"
                close-text="Close Video"
            >
                <div class="resp-container" slot="body">
                    <youtube
                        :video-id="videoId"
                        :player-vars="playerVars"
                        ref="youtube"
                    ></youtube>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from './modal';
export default {
    components: { Modal },
    props: ['videoId', 'start', 'end', 'thumb'],
    data() {
        return {
            showModal: false
        };
    },
    computed: {
        videoThumb() {
            return this.thumb
                ? this.thumb
                : this.videoId
                ? `https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg`
                : '';
        },
        playerVars() {
            //probably a better way to do this
            let vars = {};
            if (this.start) {
                vars.start = this.start;
            }
            if (this.end) {
                vars.end = this.end;
            }
            return vars;
        }
    },
    methods: {
        close() {
            this.showModal = false;
            this.$refs.youtube.player.stopVideo();
        }
    }
};
</script>

<style lang="scss">
.video-player {
    margin-bottom: 1em;

    img {
        border: solid 1px #979797;
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
}

.hotspot-content {
    .video-player {
        padding: 1em 3em;

        img {
            margin: 0;
            width: 100%;
        }
    }
}
</style>
